import cn from 'classnames';
import { ButtonHTMLAttributes, ReactElement } from 'react';

export interface BaseLinkButtonProps {
  text: string;
  additionalClass?: string;
  disabled?: boolean;
  icon?: ReactElement;
  iconPosition?: 'left' | 'right';
  size?: 'sm' | 'md' | 'lg';
  active?: boolean;
  showLine?: boolean;
}

export interface LinkButtonProps extends BaseLinkButtonProps {
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: () => void;
  isLoading?: boolean;
}

export const LinkButton = ({
  text,
  additionalClass,
  icon,
  iconPosition = 'left',
  type = 'button',
  disabled,
  isLoading,
  active = false,
  onClick,
  size = 'md'
}: LinkButtonProps) => {
  const buttonClasses = cn(
    'btn-link p-0 fw-semibold border-0 bg-white position-relative pb-4',
    {
      'fs-2': size === 'sm',
      'fs-4': size === 'lg',
      disabled: disabled || isLoading,
      'text-info': active,
      'text-muted': !active && !disabled
    },
    additionalClass
  );

  return (
    <button className={buttonClasses} type={type} onClick={onClick} disabled={disabled || isLoading}>
      {(icon || isLoading) && iconPosition === 'left' && (
        <span className="me-2">
          {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> : icon}
        </span>
      )}

      {text}

      {(icon || isLoading) && iconPosition === 'right' && (
        <span className="ms-2">
          {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> : icon}
        </span>
      )}
      {active && <div className="position-absolute bottom-0 start-0 end-0 bg-info" style={{ height: '1px' }} />}
    </button>
  );
};
